import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class LoyaltyDisplays {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-displays");

    if (!this.$el) {
      return;
    }

    this.$container = this.$el.querySelector(".js-loyalty-displays-container");
    this.$tabs = this.$el.querySelector(".js-loyalty-displays-tabs");
    this.$tabButtons = this.$el.querySelectorAll("button[data-tab]");
    this.$tabContents = this.$el.querySelectorAll("figure[data-tab-content]");

    this.$tabButtons.forEach(($button) => {
      $button.addEventListener("click", () => this.onTabClick($button));
    });

    this.animate();
    this.setupTabs();
  }

  onTabClick($button) {
    this.$tabButtons.forEach(($button) => {
      $button.classList.remove("is-active");
    });

    const tab = $button.dataset.tab;
    $button.classList.add("is-active");

    this.$tabContents.forEach(($content) => {
      const contentTab = $content.dataset.tabContent;

      if (contentTab === tab) {
        $content.classList.add("is-active");
        $content.setAttribute("aria-hidden", false);
      } else {
        $content.classList.remove("is-active");
        $content.setAttribute("aria-hidden", true);
      }
    });
  }

  setupTabs() {
    this.$tabContents.forEach(($content, index) => {
      if (index === 0) {
        $content.classList.add("is-active");
        $content.setAttribute("aria-hidden", false);
      } else {
        $content.classList.remove("is-active");
        $content.setAttribute("aria-hidden", true);
      }
    });
  }

  animate() {
    const $container = this.$el.querySelector(".js-loyalty-displays-container");
    const $tabs = this.$el.querySelector(".js-loyalty-displays-tabs");

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        scrub: true,
        end: "bottom 50%",
      },
    });

    timeline
      .from($container, {
        y: "-100px",
        opacity: 50,
        scale: 1.5,
        ease: "expo.out",
        duration: 2,
      })
      .from($tabs, {
          y: "0",
          opacity: 25,
          ease: "expo.out",
          duration: 2,
        },
        "-=1.5"
      );
  }
}
